// src/config/adsConfig.js

// Google AdSenseの設定情報をここに記述します。
// これらはAdSense管理画面で取得できるIDです。

const adsConfig = {
    // あなたのAdSenseパブリッシャーID (ca-pub-から始まる文字列)
    // public/index.html のスクリプトタグにも同じIDを設定してください。
    publisherId: "ca-pub-YOUR_ADSENSE_PUBLISHER_ID",

    // 広告ユニットのスロットID
    // 広告の種類や配置場所に応じて、複数のスロットIDを持つことができます。
    // 例: インフィード広告、ディスプレイ広告など
    adUnitIds: {
        // 例: 一般的なディスプレイ広告ユニット
        displayAd: "YOUR_ADSENSE_AD_UNIT_SLOT_ID_1",
        // 他の広告ユニットが必要な場合はここに追加
        // anotherAd: "YOUR_ADSENSE_AD_UNIT_SLOT_ID_2",
    },

    // 開発環境で広告を表示しないためのフラグ (任意)
    // ローカル開発中は false に設定し、本番環境では true または環境変数で制御することを推奨します。
    enableAds: process.env.NODE_ENV === 'production',
};

export default adsConfig;
